import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gap: '1rem',
    marginBottom: '0.5rem',
    border: '1px solid #F1F1F1',
    borderRadius: '5px',
    boxSizing: 'border-box',
    width: '95%',
    padding: '0.5rem',
    textOverflow: 'hidden',

    [theme.breakpoints.down('sm')]: {
      marginTop: '0.5rem'
    }
  },

  email: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
    cursor: 'pointer'
  },

  subject: {
    fontSize: theme.size.sm,
    fontWeight: 'bold'
  },

  info: {
    display: 'flex',
    gap: '1rem'
  },

  from: {
    fontSize: theme.size.sm
  },

  date: {
    fontSize: theme.size.sm
  },

  delete: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  deleteButton: {
    color: theme.palette.textAlt,
    cursor: 'pointer'
  }
}))

export default useStyles
